import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    label: {
        id: '_.modal.timeout_session_error.label',
        defaultMessage: 'It looks like your session timed out'
    },
    refresh: {
        id: '_.modal.timeout_session_error.refresh',
        defaultMessage: 'Refresh'
    }
});
